import { BrowserRouter as Router, Route,Routes } from "react-router-dom";




export default  function WrapperRouter({basename,children}){
    return(
    <Router basename={basename}>
        <Routes>
            {children}
        </Routes>
    </Router>
    )
}